import moment from "moment";
import "moment/locale/zh-cn";
import en from "./en";
import zh from "./zh";

const dictionaries = { en, zh };

// 语言探测：优先取 ?lang=，其次浏览器语言，非英文一律回退中文
function detectLang() {
  try {
    const match = /[?&]lang=([a-zA-Z-]+)/.exec(window.location.search);
    if (match) {
      const forced = match[1].toLowerCase();
      if (forced.startsWith("en")) return "en";
      if (forced.startsWith("zh")) return "zh";
    }
  } catch (e) {
    // ignore
  }
  const navLang = (
    (typeof navigator !== "undefined" && (navigator.language || (navigator.languages && navigator.languages[0]))) ||
    "zh"
  ).toLowerCase();
  return navLang.startsWith("en") ? "en" : "zh";
}

let currentLang = detectLang();

function applyLang() {
  if (typeof document !== "undefined") {
    document.documentElement.lang = currentLang === "en" ? "en" : "zh-cn";
  }
  moment.locale(currentLang === "en" ? "en" : "zh-cn");
}
applyLang();

export function getLang() {
  return currentLang;
}

export function setLang(lang) {
  currentLang = dictionaries[lang] ? lang : "zh";
  applyLang();
  return currentLang;
}

function resolve(dict, key) {
  return key.split(".").reduce((acc, k) => (acc && acc[k] != null ? acc[k] : undefined), dict);
}

// 取文案，支持 {name} 形式的插值，缺失时回退中文，再缺失则原样返回 key
export function t(key, params) {
  const dict = dictionaries[currentLang] || dictionaries.zh;
  let str = resolve(dict, key);
  if (str == null) str = resolve(dictionaries.zh, key);
  if (str == null) return key;
  if (params) {
    Object.keys(params).forEach((k) => {
      str = str.replace(new RegExp(`\\{${k}\\}`, "g"), params[k]);
    });
  }
  return str;
}

// 日期格式化：中文用 年月日，英文用 MMM D, YYYY
export function formatDate(value, short = false) {
  const m = moment(value);
  if (!m.isValid()) return "";
  if (currentLang === "en") {
    return m.format(short ? "MMM D" : "MMM D, YYYY");
  }
  return m.format(short ? "M月D日" : "YYYY年M月DD日");
}

// 播放量：中文万位显示 w，英文千位显示 K
export function formatPv(pv) {
  const num = pv || 0;
  if (currentLang === "en") {
    return num >= 1000 ? `${Math.round(num / 1000)}K` : num;
  }
  return num >= 100000 ? `${parseInt(num / 10000, 10)}w` : num;
}
